import axios from "axios";
import { getHeaders } from '../helpers';
import { getChestApiUrl } from '../../helpers/index';


/**
 * Get product info from sesison.
 * 
 * @param {String} params.s Session of the user
 */
const getInfo = params => axios({
  method: 'get',
  url: `${getChestApiUrl()}/chestApi/data/info`,
  headers: getHeaders(),
  params
})


export default {
  getInfo
}